import { useEffect, useState } from "react";
import { api, formatError } from "../lib/api";
import { Card } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "../components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";
import { toast } from "sonner";
import { Plus } from "lucide-react";

export default function ChannelPartners() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ company_name: "", contact_person: "", mobile: "", email: "", city: "", category: "standard", tier: "B" });
  const load = () => api.get("/cps").then(r => setItems(r.data));
  useEffect(() => { load(); }, []);
  const submit = async () => {
    try { await api.post("/cps", form); toast.success("CP created"); setOpen(false); load(); }
    catch (e) { toast.error(formatError(e.response?.data?.detail) || e.message); }
  };
  return (
    <div className="space-y-6 animate-in">
      <div className="flex items-end justify-between">
        <div>
          <div className="text-[11px] uppercase tracking-[0.3em] text-muted-foreground">Sourcing</div>
          <h1 className="font-serif-display text-3xl">Channel Partners</h1>
        </div>
        <Dialog open={open} onOpenChange={setOpen}>
          <DialogTrigger asChild><Button data-testid="new-cp-btn"><Plus size={14} className="mr-1"/> New CP</Button></DialogTrigger>
          <DialogContent>
            <DialogHeader><DialogTitle>Register Channel Partner</DialogTitle></DialogHeader>
            <div className="grid grid-cols-2 gap-3">
              <div className="col-span-2"><Label>Company Name</Label><Input value={form.company_name} onChange={e => setForm({ ...form, company_name: e.target.value })} data-testid="cp-company-input"/></div>
              <div><Label>Contact Person</Label><Input value={form.contact_person} onChange={e => setForm({ ...form, contact_person: e.target.value })}/></div>
              <div><Label>Mobile</Label><Input value={form.mobile} onChange={e => setForm({ ...form, mobile: e.target.value })}/></div>
              <div><Label>Email</Label><Input value={form.email} onChange={e => setForm({ ...form, email: e.target.value })}/></div>
              <div><Label>City</Label><Input value={form.city} onChange={e => setForm({ ...form, city: e.target.value })}/></div>
              <div><Label>Category</Label>
                <Select value={form.category} onValueChange={v => setForm({ ...form, category: v })}>
                  <SelectTrigger><SelectValue/></SelectTrigger>
                  <SelectContent>{["platinum","gold","silver","standard","dormant"].map(x => <SelectItem key={x} value={x}>{x}</SelectItem>)}</SelectContent>
                </Select>
              </div>
              <div><Label>Tier</Label>
                <Select value={form.tier} onValueChange={v => setForm({ ...form, tier: v })}>
                  <SelectTrigger><SelectValue/></SelectTrigger>
                  <SelectContent>{["A","B","C"].map(x => <SelectItem key={x} value={x}>{x}</SelectItem>)}</SelectContent>
                </Select>
              </div>
            </div>
            <DialogFooter><Button onClick={submit} data-testid="cp-submit-btn">Save CP</Button></DialogFooter>
          </DialogContent>
        </Dialog>
      </div>
      <Card className="overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-secondary/50 text-[11px] uppercase tracking-wider text-muted-foreground">
            <tr><th className="text-left px-4 py-3">Code</th><th className="text-left px-4 py-3">Company</th><th className="text-left px-4 py-3">Contact</th><th className="text-left px-4 py-3">Mobile</th><th className="text-left px-4 py-3">Category</th><th className="text-left px-4 py-3">Tier</th><th className="text-left px-4 py-3">Status</th></tr>
          </thead>
          <tbody>
            {items.map(c => (
              <tr key={c.id} className="border-t border-border hover:bg-accent/5">
                <td className="px-4 py-3 font-mono text-xs">{c.cp_code}</td>
                <td className="px-4 py-3">{c.company_name}</td>
                <td className="px-4 py-3">{c.contact_person}</td>
                <td className="px-4 py-3 font-mono text-xs">{c.mobile}</td>
                <td className="px-4 py-3 capitalize">{c.category}</td>
                <td className="px-4 py-3">{c.tier}</td>
                <td className="px-4 py-3 capitalize">{c.status}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
